<template>
  <div id="reporteador" class="zindex100">
    <div
      class="separador text-center mt-5 py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class="blockd fXG blanco">Tickets Registrados</p>

      <p class="">
        <button @click="logout" class="btn btn-info">Cerrar sesión</button>
      </p>
    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG blanco">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-6 py-5">
          <router-link class="btn btn-danger" to="/reportes/descarga"
            >Descarga de usuarios &raquo;
          </router-link>
        </div>
      </div>

      <b-tabs content-class="mt-3 row zindex100">
        <b-tab title="Participaciones">
          <div class>
            <div class="col-12 blanco pt-5 pb-3">
              <span class="blockd fG">Tickets</span>
              (Total: {{ tickets.length }})
            </div>

            <div class="col-12 zindex100">
              <download-excel
                :data="this.tickets"
                name="Tickets Raspa y Gana.xls"
              >
                <button class="btn btn-danger">Exportar Tickets</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                class="blanco"
                :columns="columns"
                v-model="tickets"
                :options="options"
              >
                <a
                  slot="uri"
                  slot-scope="props"
                  target="_blank"
                  :href="props.row.uri"
                  class="glyphicon glyphicon-eye-open"
                  >Ver</a
                >

                <div slot="child_row" slot-scope="props" class="d-flex">
                  <a target="_blank" :href="props.row.ticket_img_url">
                    <img
                      :src="props.row.ticket_img_url"
                      alt="imagen ticket"
                      width="100"
                    />
                  </a>

                  <div class="px-3">
                    <p>Selecciona un estatus de validación:</p>
                    <p>
                      <select
                        class="form-control"
                        name=""
                        id=""
                        v-model="props.row.status"
                      >
                        <option value="por validar" hidden>
                          Selecciona un status
                        </option>
                        <option
                          value="inválido"
                          :selected="props.row.status == 'inválido'"
                        >
                          Inválido
                        </option>

                        <option
                          value="válido"
                          :selected="
                            props.row.status == 'válido'
                          "
                        >
                          Válido
                        </option>
                        
                      </select>
                    </p>
                    <p>
                      <span class="d-block"
                        >Ingresa el monto del ticket con productos
                        participantes:</span
                      >
                      <input
                        v-if="mostrar_monto == true"
                        type="number"
                        v-model="monto"
                        class="form-control"
                      />
                    </p>
                    <p>
                      <button
                        class="btn-amarillo px-5"
                        @click="
                          changeStatusTicket(
                            props.row.id,
                            props.row.user_id,
                            props.row.status,
                            props.row.email
                          )
                        "
                      >
                        <span class="negro">Actualizar estatus</span>
                      </button>
                    </p>
                  </div>
                </div>

                <div
                  slot="name"
                  slot-scope="{
                    row,
                    update,
                    setEditing,
                    isEditing,
                    revertValue,
                  }"
                >
                  <span @click="setEditing(true)" v-if="!isEditing()">
                    <a>{{ row.name }}</a>
                  </span>
                  <span v-else>
                    <input type="text" v-model="row.name" />
                    <button
                      type="button"
                      class="btn btn-info btn-xs"
                      @click="
                        update(row.name);
                        setEditing(false);
                      "
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      @click="
                        revertValue();
                        setEditing(false);
                      "
                    >
                      Cancel
                    </button>
                  </span>
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    // Glyphicons,
  },
  data() {
    return {
      columns: [
        "status",
        "week",
        "created_on_server",
        "tipo_premio",
        "nombre",
        "apellido",
        "email",
        "respuesta_correcta",
        "respuesta",
        "pregunta.pregunta",
        "pregunta.r1",
        "pregunta.r2",
        "pregunta.r3",
        // "started_on",
        // "finished_on",
        // "diferencia_segundos_user",

        "finished_on_server",
        "diferencia_segundos_servidor",
        "id",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id: "Ticket UID",
          week: "Semana",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          puntos_convertidos: "Puntos",
          puntos_acumulados: "Puntos agregados por ticket",
          status: "Status Participación",
          tipo_cupon: "Tipo Cupón",
          codigo_dulceria: "Cupón Dulcería",
          codigo_oxxo: "Cupón OXXO",
          tiempo: "Tiempo Participación",
          segundos: "Segundos Participación",
          intento_trampa:
            "Posible Trampa (si fecha, campo válido: Segundos Servidor)",
          // started_on: "Fecha Ini User",
          // finished_on: "Fecha Fin User",
          // diferencia_segs_user: "Segundos User",
          created_on_server: "Fecha Registro (Servidor)",
          finished_on_server: "Fecha Fin de Participación (Servidor)",
          diferencia_segundos_servidor: "Segundos Servidor",
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "user_id",
        "nombre",
        "apellido",
        "email",
        "genero",
        "celular",
        "fecha_nacimiento",
        "edad",
        "suma_puntos",
        "suma_time",
        "suma_time_txt",
        "num_tickets",
        "created_on",
        "dia_registro",
      ],
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          genero: "Genero",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: ["edad", "suma_puntos", "suma_time", "num_tickets"],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      mostrar_monto: false,
      monto: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutReportes");
    },
    async init() {
      this.$store.dispatch("showLoader", true);
      await this.getUsers();
      await this.getTickets();
    },
    seleccionaStatusChange(status) {
      this.monto = 0;
      console.log(status);
      if (
        status == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
      ) {
        this.mostrar_monto = true;
      } else {
        this.mostrar_monto = false;
      }
    },
    async getTickets() {
      console.log("getting tickets");
      const docs = await ticketsCollection
        //.where("status", "==", "por validar")
        .get();

      //await this.getAhora();

      this.tickets = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        //console.log(ticket.user_id );

        //if (ticket.user_id == "Vu7dm3jyJlNFCiVJdLov9ze2PeI2") return;

        ticket.id = doc.id;

        try {
          ticket.nombre = this.users[ticket.user_id].nombre;
        } catch (err) {
          ticket.nombre = "";
        }
        try {
          ticket.apellido = this.users[ticket.user_id].apellido;
        } catch (err) {
          ticket.apellido = "";
        }
        try {
          ticket.email = this.users[ticket.user_id].email;
        } catch (err) {
          ticket.email = "";
        }
        try {
          ticket.celular = this.users[ticket.user_id].celular;
        } catch (err) {
          ticket.celular = "";
        }
        try {
          ticket.fecha_nacimiento = moment(
            this.users[ticket.user_id].fecha_nacimiento
          ).format("DD/MM/YYYY");
        } catch (err) {
          ticket.fecha_nacimiento = "";
        }

        try {
          ticket.tiempo = this.secondsToHms(ticket.time);
        } catch (err) {
          //console.log({ errortime: err });
          //console.log({errortimesuser: ticket.user.id});
        }

        ticket.segundos = ticket.time;
        ticket.puntos_convertidos = ticket.puntos_totales;

        // try {
        //   ticket.week = this.getNumSemana(
        //     this.getFechaFormato(repo)
        //   );
        // } catch (err) {
        //   console.log({ weekerror: err });
        //   ticket.week = -1;
        // }

        try {
          ticket.monto.toString();
        } catch (err) {
          ticket.monto = 0;
        }

        //this.sumaStatsUser(ticket.user_id, ticket.puntos, ticket.time);

        try {
          ticket.intento_trampa = moment
            .unix(ticket.intento_trampa.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.intento_trampa = "";
        }

        // ticket.diferencia_segundos_user = this.calculaDiferenciaTiempos(
        //   ticket.started_on,
        //   ticket.finished_on
        // );
        // console.log(ticket.diferencia_segundos_user);
        try {
          ticket.started_on = moment
            .unix(ticket.started_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.started_on = "";
        }
        try {
          ticket.finished_on = moment
            .unix(ticket.finished_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.finished_on = "";
        }

        try {
          ticket.diferencia_segundos_servidor = this.calculaDiferenciaTiempos(
            ticket.created_on_server,
            ticket.finished_on_server
          );
        } catch (e) {
          ticket.diferencia_segundos_servidor = "";
        }

        try {
          ticket.created_on_server = moment
            .unix(ticket.created_on_server.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.created_on_server = "";
        }
        try {
          ticket.finished_on_server = moment
            .unix(ticket.finished_on_server.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.finished_on_server = "";
        }

        this.tickets.push(ticket);
      });
      this.tickets = this.tickets.sort(this.custom_sort);
      //console.log({ tickets: this.tickets });

      //this.setUsersArray();
      this.$store.dispatch("showLoader", false);
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    sumaStatsUser(user_id, puntos, time) {
      if (puntos == undefined) puntos = 0;
      if (time == undefined) time = 0;

      let multiplicador = 1;

      // console.log(user_id);
      // console.log(this.users[user_id]);

      if (this.users[user_id] == undefined) return;

      if (this.users[user_id].suma_puntos == undefined)
        this.users[user_id].suma_puntos = 0;
      try {
        this.users[user_id].suma_puntos += parseInt(puntos) * multiplicador;
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].suma_time == undefined)
        this.users[user_id].suma_time = 0;
      try {
        this.users[user_id].suma_time += parseInt(time);
        this.users[user_id].suma_time_txt = this.secondsToHms(
          this.users[user_id].suma_time
        );
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].num_tickets == undefined)
        this.users[user_id].num_tickets = 0;
      try {
        this.users[user_id].num_tickets++;
      } catch (err) {
        console.log(err);
      }
    },
    calculaDiferenciaTiempos(started, finished) {
      try {
        //console.log({ started: started.seconds });
        //console.log({ finished: finished.seconds });
        if (started.seconds == null || finished.seconds == null) return "error";
        let d1 = moment.unix(started.seconds);
        //console.log({ d1: d1 });
        let d2 = moment.unix(finished.seconds);
        //console.log({ d2: d2 });
        return d2.diff(d1, "seconds");
      } catch (err) {
        return "error";
      }
    },
    async getUsers() {
      console.log("getting users");
      //const docs = await usersCollection.limit(100).get();
      const docs = await usersCollection.get();
      //console.log({ userDocs: docs });
      this.users = {};
      docs.forEach((doc) => {
        let user = doc.data();
        //user.id = doc.id;
        //console.log(doc.id)

        try {
          if (user.created_on.seconds != undefined) {
            console.log("encontro fecha nueva");
            user.created_on = moment
              .unix(user.created_on.seconds)
              .format("ddd, DD MMM YYYY HH:mm:ss");

            user.dia_registro = moment(user.created_on).format("DD MMM");
          } else {
            user.dia_registro = moment(user.created_on).format("DD MMM");
          }
        } catch (err) {
          console.log({ fecha_error: err });
        }

        //console.log({ fecha: user.dia_registro });

        this.users[doc.id] = user;
      });
      console.log({ users: this.users });
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
    async changeStatusTicket(id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      await this.$store.dispatch("changeStatusTicketValidacion", {
          status: value,
          ticket_id: id,
          user_id: userId
        });

      //this.getTickets();

      for(var i = 0; i < this.tickets.length; i++){
        if(this.tickets[i].id === id){
          this.tickets[i].status = value;
        }
      }


    },
  },
};
</script>

<style scoped>
select {
  color: black;
}
select option {
  color: black;
}
</style>

